
/*global
gsap,
ScrollTrigger,
SplitText,
Splide,
jQuery
 */
/*eslint no-undef: "error"*/
/*eslint-env browser*/

// Make jQuery available if needed
const $j = jQuery.noConflict();

//// Site functions ////

// Hide me show me header
function headerHideShow() {
    let didScroll;
    let lastScrollTop = 0;

    const delta = 5;
    const navbar = document.querySelector("#site-header");
    const navbarHeight = navbar.offsetHeight;

    window.addEventListener("scroll", () => {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        let st = window.pageYOffset;

        if (Math.abs(lastScrollTop - st) <= delta) return;

        if (st > lastScrollTop && st > (navbarHeight * 2)) {
            // Scroll Down
            navbar.classList.remove("nav-down");
            navbar.classList.add("nav-up");
        } else {
            // Scroll Up
            if (st + window.innerHeight < document.body.clientHeight) {
                navbar.classList.remove("nav-up");
                navbar.classList.add("nav-down");
            }
        }

        lastScrollTop = st;
    }

    // Change header on scroll
    function navScroll() {
        let $sticky = $j('#site-header'),
            $scroll = $j(window).scrollTop();

        if ($scroll > navbarHeight) {
            if (!$sticky.hasClass('scrolled')) {
                $sticky.addClass('scrolled');
            }
        } else {
            $sticky.removeClass('scrolled');
        }
    }
    navScroll();
    $j(window).on('scroll resize', navScroll);

}


// Smooth scroll
function smoothScroll() {
    const links = document.querySelectorAll("a[href*='#']:not([href='#']):not([href='#0'])");

    for (const link of links) {
        link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;

        scroll({
            // top: offsetTop - 130,
            top: offsetTop,
            behavior: "smooth"
        });
    }
}

// GSAP animations
// Animate on scroll (GSAP)
// - add scripts that apply to your results here

function gsapAnimateScroll() {
    const faders = gsap.utils.toArray("[data-vas='fade']");

    if (typeof (faders) != 'undefined' && faders != null) {

        faders.forEach((fader) => {

            gsap.set(fader, {
                autoAlpha: 0
            });

            // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
            let faderDelay;

            if (fader.hasAttribute("data-vas-delay")) {
                faderDelay = fader.getAttribute("data-vas-delay");
            } else {
                faderDelay = 0;
            }

            ScrollTrigger.create({
                trigger: fader,
                start: "25% bottom",
                //markers: true,
                onEnter: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        delay: faderDelay,
                        overwrite: true
                    }),
                onLeave: () =>
                    gsap.to(fader, {
                        autoAlpha: 0,
                        overwrite: true
                    }),
                onEnterBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        overwrite: true
                    }),
                onLeaveBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 0,
                        overwrite: true
                    })
            });
        });

    }

    // Slide up
    const fadersSU = gsap.utils.toArray("[data-vas='fade-up']");

    if (typeof (fadersSU) != 'undefined' && fadersSU != null) {

        fadersSU.forEach((faderSU) => {

            gsap.set(faderSU, {
                y: 50,
                autoAlpha: 0
            });

            // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
            let faderDelay;

            if (faderSU.hasAttribute("data-vas-delay")) {
                faderDelay = faderSU.getAttribute("data-vas-delay");
            } else {
                faderDelay = 0;
            }            

            ScrollTrigger.create({
                trigger: faderSU,
                start: "25% bottom",
                onEnter: () =>
                    gsap.to(faderSU, {
                        y: 0,
                        autoAlpha: 1,
                        duration: 1,
                        delay: faderDelay,
                        overwrite: true
                    }),
                onLeaveBack: () =>
                    gsap.to(faderSU, {
                        y: 100,
                        autoAlpha: 0,
                        duration: 1,
                        overwrite: true
                    })

            });

        });

    }

}

// GSAP-powered cursor-follow
// function followCursor() {

//     gsap.set(".follow-cursor", { xPercent: -50, yPercent: -50 });

//     const ball = document.querySelector(".follow-cursor");
//     const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
//     const mouse = { x: pos.x, y: pos.y };
//     const speed = 0.35;

//     const xSet = gsap.quickSetter(ball, "x", "px");
//     const ySet = gsap.quickSetter(ball, "y", "px");

//     window.addEventListener("mousemove", e => {
//         mouse.x = e.x;
//         mouse.y = e.y;
//     });

//     gsap.ticker.add(() => {

//         // adjust speed for higher refresh monitors
//         const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

//         pos.x += (mouse.x - pos.x) * dt;
//         pos.y += (mouse.y - pos.y) * dt;
//         xSet(pos.x);
//         ySet(pos.y);
//     });

//     gsap.utils.toArray("a, .btn, .follow, input[type='submit'], .sf-label-radio").forEach(el => {
//         el.addEventListener("mouseenter", () => {
//             gsap.to(ball, { scale: 3.0, opacity: 0.6, duration: 0.25 });
//         });
//         el.addEventListener("mouseleave", () => {
//             gsap.to(ball, { scale: 1, opacity: 1.0, duration: 0.1 });
//         });
//     })

// }

//// Key site elements ////
function headerParallax() {
    const headBg = document.querySelector(".bg-parallax");

    if (typeof (headBg) != 'undefined' && headBg != null) {

        //let nav = document.querySelector("#site-navigation");
        //let navHeight = nav.offsetHeight;

        gsap.to(headBg, {
            y: 200,
            scrollTrigger: {
                trigger: headBg,
                start: "top 60px", //start: "top " + navHeight + "px"
                scrub: true
            }
        });

    }

}

// Product circle animation
function productCircle() {

    if ($j('.flx-textimage__circle-bg').length > 0) {

        let circles = gsap.utils.toArray('.flx-textimage__circle-bg');

        circles.forEach((circle) => {

            gsap.set(circle, {
                scale: 0.7,
                autoAlpha: 0
            })

            gsap.to(circle, {
                scrollTrigger: {
                    trigger: circle,
                    // markers: true,
                    start: "top 80%",
                    end: "bottom 20%",
                    scrub: true
                },
                autoAlpha: 1,
                scale: 1
            });

        });

    }

}

// Play hero video
function heroVideo() {

    if ($j('.header-hero-video').length > 0) {

        let videos = gsap.utils.toArray(".header-hero-video__video");

        videos.forEach((video) => {
            ScrollTrigger.create({
                trigger: video,
                start: "top center", // top center
                end: "bottom 25%", // bottom center
                onEnter: () => {
                    video.play();
                },
                onLeave: () => {
                    video.pause();
                },
                onEnterBack: () => {
                    video.play();
                },
                onLeaveBack: () => {
                    video.pause();
                }
            });
        });

    }

}


// Staggered text reveal
function stagTextReveal() {

    if ($j('.stagRev').length > 0) {

        const innerSplit = SplitText.create(".stagRev", {
            type: "words",
            linesClass: "split-inner"
        });

        SplitText.create(".stagRev", {
            type: "lines",
            linesClass: "split-outer"
        });

        ScrollTrigger.batch(innerSplit.words, {
            start: "top 90%",
            once: true,
            onEnter: batch => gsap.to(batch, { yPercent: 0, duration: 0.8, stagger: 0.1, ease: "power4" })
        });

        gsap.set(innerSplit.words, { yPercent: 100 });

        // since we're moving the initial position DOWN (yPercent: 100), it would affect where the triggers line up, but we want to base things on the natural position, so on the "refreshInit" event, we restore it. ScrollTrigger automatically reverts the tween we return. 
        ScrollTrigger.addEventListener("refreshInit", () => gsap.set(innerSplit.words, { yPercent: 0 }));

    }

}

function socnetAnim() {

    if ($j('.footer-signup__socnets').length > 0) {

        let socnets = gsap.utils.toArray('.footer-signup__socnets .social-links__link');
        let trigger = document.querySelector(".footer-signup");

        socnets.forEach((socnet) => {

            gsap.set(socnet, {
                x: 500
            });

            gsap.to(socnet, {
                duration: 4.0,
                x: 0,
                transformOrigin: "50% 50%",
                rotateZ: -720,
                ease: "back.out(1.7)",                
                scrollTrigger: {
                    trigger: trigger,
                    start: "top bottom",
                    end: "bottom top"
                }
            });

        });

    }

}

// Sticky elements
function stickyElements() {

    const stickyContainer = document.querySelector(".sticky-container");

    if (typeof (stickyContainer) != 'undefined' && stickyContainer != null) {

        const stickyThing = document.querySelector(".sticky-content");

        gsap.to(stickyContainer, {
            scrollTrigger: {
                trigger: stickyContainer,
                pin: stickyThing,
                // markers: true,
                start: "top 50px",
                end: "bottom 120px",
                onEnter: () => $j('#site-header').addClass('anim-nav-up'),
                onLeave: () => $j('#site-header').removeClass('anim-nav-up'),
                onEnterBack: () => $j('#site-header').addClass('anim-nav-up'),
                onLeaveBack: () => $j('#site-header').removeClass('anim-nav-up')
            }
        });

    }

}

function navDesktop() {
    let $menuItem = $j("#menu-main__desktop > li.menu-item-has-children > a");
    let $subMenu = $j("#menu-main__desktop > li.menu-item-has-children > ul.sub-menu");
    // let $subMenuItem = $j("#menu-main__desktop > li.menu-item-has-children > ul.sub-menu > li.menu-item-has-children > a");
    // let $subSubMenu = $j("#menu-main__desktop > li.menu-item-has-children > ul.sub-menu > li.menu-item-has-children > ul.sub-menu");

    $menuItem.on("click", function () {
        $j(this).toggleClass("active");
        $j(this).siblings($subMenu).fadeToggle();
        $j(this).parent().siblings(".menu-item-has-children").find($subMenu).fadeOut();
        $j(this).parent().siblings(".menu-item-has-children").children($menuItem).removeClass("active");
    });

    // $subMenuItem.on("click", function () {
    //     $j(this).toggleClass("active");
    //     $j(this).siblings($subSubMenu).fadeToggle();
    //     $j(this).siblings($subMenuItem).removeClass("active");
    // });

    $j(document).click(function (event) {
        var $target = $j(event.target);
        if (!$target.closest($menuItem).length &&
            !$target.closest($subMenu).length &&
            $subMenu.is(":visible")) {
            $subMenu.fadeOut();
            $menuItem.removeClass("active");
        }
    });

}

function navMobile() {
    const navOpen = document.querySelector("#nav-open");
    const navContainer = document.querySelector("#nav-mobile");
    const burger = document.querySelector("#nav-icon");
    const burgerWrap = document.querySelector("#nav-icon__wrap");

    navOpen.addEventListener("click", function () {
        if(!navOpen.classList.contains('nav-open')) {

            gsap.to(navContainer, {
                display: "block"
            });
            gsap.to(navContainer, {
                autoAlpha: 1
            });

            document.documentElement.classList.add("noscroll");
            document.querySelector(".navbar-brand").classList.add("menu-open");
            navOpen.classList.add("nav-open");
            burger.classList.add("open");
            burgerWrap.classList.add("open");

        } else {
            gsap.to(navContainer, {
                autoAlpha: 0
            });
            gsap.to(navContainer, {
                display: "none"
            });
            document.documentElement.classList.remove("noscroll");
            document.querySelector(".navbar-brand").classList.remove("menu-open");
            navOpen.classList.remove("nav-open");
            burger.classList.remove("open");
            burgerWrap.classList.remove("open");
        }
    });

}

// function siteSearch() {
//     const searchOpen = document.querySelector("#search-open");
//     const searchOpenMob = document.querySelector("li.search-link");
//     const searchClose = document.querySelector("#search-close");
//     const searchModal = document.querySelector("#site-search");

//     searchOpen.addEventListener("click", function () {
//         gsap.to(searchModal, {
//             autoAlpha: 1
//         });
//     });

//     searchOpenMob.addEventListener("click", function () {
//         gsap.to(searchModal, {
//             autoAlpha: 1
//         });
//     });

//     searchClose.addEventListener("click", function () {
//         gsap.to(searchModal, {
//             autoAlpha: 0
//         });
//     });

// }

function footerMenuAccordion() {

    const footerMenus = document.querySelectorAll(".mobile-footer-menu");

    if (typeof (footerMenus) != 'undefined' && footerMenus != null) {

        const openAccordion = (footerMenu) => {
            const heading = footerMenu.querySelector("h3");
            const content = footerMenu.querySelector("ul");
            heading.classList.add("active");
            content.classList.add("open");
            content.style.maxHeight = content.scrollHeight + "px";
            // $j(content).slideDown();
        };

        const closeAccordion = (footerMenu) => {
            const heading = footerMenu.querySelector("h3");
            const content = footerMenu.querySelector("ul");
            heading.classList.remove("active");
            content.classList.remove("open");
            // $j(content).slideUp();
            content.style.maxHeight = null;
        };

        footerMenus.forEach((footerMenu) => {
            const intro = footerMenu.querySelector("h3");
            const content = footerMenu.querySelector("ul");

            intro.onclick = () => {
                if (content.classList.contains("open")) {
                    closeAccordion(footerMenu);
                } else {
                    footerMenus.forEach((footerMenu) => closeAccordion(footerMenu));
                    openAccordion(footerMenu);
                }
            };
        });

    } else {
        return;
    }

}

function featureTabs() {

    if ($j('.feature-tabs__tabs').length > 0) {

        const allTabs = document.querySelectorAll('.tabs__content-panel');
        const firstTab = document.querySelector('.tabs__content-panel:first-child');
        const firstLink = document.querySelector('.tabs__links > a:first-child');

        $j(allTabs).hide();
        $j(firstTab).show().addClass('active');
        $j(firstLink).addClass('active');

        $j('[data-tab]').on('click', function (e) {
            $j(this).addClass('active').siblings('[data-tab]').removeClass('active')
            $j('.tabs__content-panel[data-content=' + $j(this).data('tab') + ']').show().addClass('active').siblings('[data-content]').hide().removeClass('active')
            e.preventDefault()
        })

    }

}

// Lottie files
function lottieTrigger() {

    if ($j('.lottie-anim').length > 0) {

        let zones = gsap.utils.toArray('.lottie-anim');

        zones.forEach((zone) => {

            let player = zone.querySelector("lottie-player");

            gsap.to(player, {
                autoAlpha: 0
            }),

                ScrollTrigger.create({
                    trigger: zone,
                    start: "top bottom",
                    end: "bottom top",
                    onEnter: () => {
                        player.seek(0);
                        setTimeout(function () {
                            player.play();
                            gsap.to(player, {
                                autoAlpha: 1,
                                duration: 1
                            })
                        }, 1000);
                    },
                    onLeave: () => {
                        player.stop();
                        player.seek(0);
                    },
                    onEnterBack: () => {
                        player.play();
                    },
                    onLeaveBack: () => {
                        player.stop();
                    }
                });


        });

    }

}


//// Flexible content functions ////

// Accordion
function flxAccordion() {
    const accordions = document.querySelectorAll(".flx-accordion__row");

    if (typeof (accordions) != 'undefined' && accordions != null) {

        const openAccordion = (accordion) => {
            const heading = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");
            heading.classList.add("active");
            content.classList.add("open");
            content.style.maxHeight = content.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
            const heading = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");
            heading.classList.remove("active");
            content.classList.remove("open");
            content.style.maxHeight = null;
        };

        accordions.forEach((accordion) => {
            const intro = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");

            intro.onclick = () => {
                if (content.classList.contains("open")) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        });

    } else {
        return;
    }
}

// Hero slider
function heroSlider() {
    const slider = document.querySelector(".header-hero__slider");
    const sliderThumbs = document.querySelector(".header-hero__thumbnail-slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        var main = new Splide(slider, {
            type: 'fade',
            updateOnMove: true,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 5000,
            speed: 1000,
            pauseOnHover: false,
            rewind: true,
            easing: 'cubic-bezier(.26,.32,.7,.79)',
            perPage: 1
        });

        var thumbnails = new Splide(sliderThumbs, {
            type: 'slide',
            arrows: false,
            pagination: false,
            isNavigation: true
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();

    } else {
        return;
    }

}

function flxSlideshow() {

    const slider = document.querySelector(".flx-slideshow__slider");
    const sliderThumbs = document.querySelector(".flx-slideshow__thumbnail-slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        var main = new Splide(slider, {
            type: 'fade',
            updateOnMove: true,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 4000,
            speed: 2000,
            rewind: true,
            pauseOnHover: false
        });

        var thumbnails = new Splide(sliderThumbs, {
            type: 'slide',
            arrows: false,
            pagination: false,
            isNavigation: true
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();

    } else {
        return;
    }

}

// Image banner parallax
function flxImgBannerParallax() {

    if ($j('.flx-imagebanner').length > 0) {

        let parallaxDots = gsap.utils.toArray('.img-dots');

        parallaxDots.forEach((parallaxDot) => {

            gsap.to(parallaxDot, {
                y: 200,
                autoAlpha: 0,
                scrollTrigger: {
                    trigger: parallaxDot,
                    start: "top top",
                    scrub: true
                }
            });

        });

    }
}

// Case study slider
function flxCsSlider() {
    const slider = document.querySelector(".flx-cs-feed__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 8000,
            speed: 800,
            gap: '5.1rem',
            perPage: 1
        });

        splide.mount();

        // Move arrows
        // $j(".flx-ins-feed__pagination").appendTo("#ins-feed-dots");

    } else {
        return;
    }
}

// Insights slider
function flxInsSlider() {
    const slider = document.querySelector(".flx-ins-feed__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 8000,
            speed: 800,
            gap: '5.1rem',
            perPage: 2,
            breakpoints: {
                1400: {
                    gap: '3rem'
                },
                767: {
                    perPage: 1
                }
            }
        });

        splide.mount();

        // Move arrows
        $j(".flx-ins-feed__pagination").appendTo("#ins-feed-dots");

    } else {
        return;
    }
}

// Logo slider
function flxLogoSlider() {
    const slider = document.querySelector(".flx-logos__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: "loop",
            direction:'ltr',
            drag: false,
            pagination:false,
            arrows:false,
            dragAngleThreshold: 0,
            focus: "center",
            perPage: 4,
            breakpoints: {
                991: {
                    perPage: 3
                },
                600: {
                    perPage: 2
                }
            },
            autoScroll: {
              speed: 1.5,
              pauseOnHover: true
            }
        });

        splide.mount(window.splide.Extensions);

    } else {
        return;
    }
}

function flxScrollingText() {

    let scrollingText = document.querySelector("#scrolling-text");

    if (typeof (scrollingText) != 'undefined' && scrollingText != null) {

        gsap.to(scrollingText, {
            x: -900,
            scrollTrigger: {
                trigger: scrollingText,
                start: "top bottom",
                end: "bottom top",
                scrub: true
                // markers: true
            }
        });

    }

}

function parallaxFeatures() {

    if ($j('.parallax-effect').length > 0) {

        let parallaxItems = gsap.utils.toArray('.parallax-effect');

        parallaxItems.forEach((parallaxItem) => {

            gsap.to(parallaxItem, {
                y: -60,
                scrollTrigger: {
                    trigger: parallaxItem,
                    start: "top 70%",
                    end: "bottom top",
                    scrub: true
                }
            });

            gsap.set(parallaxItem, {
                autoAlpha: 0
            })

            ScrollTrigger.create({
                trigger: parallaxItem,
                start: "top 65%",
                end: "bottom top",
                onEnter: () =>
                    gsap.to(parallaxItem, {
                        autoAlpha: 1,
                        duration: 1,
                        delay: 0.2
                    }),
                onLeave: () =>
                    gsap.to(parallaxItem, {
                        autoAlpha: 0
                    }),
                onEnterBack: () =>
                    gsap.to(parallaxItem, {
                        autoAlpha: 1,
                        duration: 1,
                        delay: 0.2
                    }),
                onLeaveBack: () =>
                    gsap.to(parallaxItem, {
                        autoAlpha: 0,
                        duration: 1
                    })

            });

        });

    }


}

// function animatedStat() {

//     // Animate stats
//     const items = document.querySelectorAll(".stat");

//     gsap.from(items, {
//         textContent: 0,
//         duration: 3,
//         ease: "power1.in",
//         snap: {
//             textContent: 1
//         },
//         scrollTrigger: {
//             trigger: ".flx-imagebanner",
//             start: "top bottom",
//             end: "bottom top"
//         }
//     });

// }



function vanillaModal() {
    const modals = document.querySelectorAll("[data-modal]");
    const body = document.documentElement;

    modals.forEach(function (trigger) {
        const modal = document.getElementById(trigger.dataset.modal);
        const exits = modal.querySelectorAll(".modal-exit");

        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            modal.classList.add("open");
            body.classList.add("noscroll");
            exits.forEach(function (exit) {
                exit.addEventListener("click", function (event) {
                    event.preventDefault();
                    modal.classList.remove("open");
                    body.classList.remove("noscroll");
                });
            });
        });
    });

}


//// Other pages ////

// function masonry() {
//     let msnryContainer = document.querySelector('.flx-msnry-block__wrap');

//     if (typeof(msnryContainer) != 'undefined' && msnryContainer != null) {

//         let msnry = new Masonry(msnryContainer, {
//             // options
//             itemSelector: '.msnry-elem',
//             columnWidth: '.msnry-col',
//             gutter: '.msnry-gut',
//             percentPosition: true
//         });

//         msnry.layout();

//     } else {
//         return;
//     }

// }

// $('[data-fancybox]').fancybox({
//     thumbs : {
//       autoStart   : true,
//       hideOnClose : true
//     },
//   });

function fancybox() {

    $j('[data-fancybox="gallery"]').fancybox({
        thumbs : {
        autoStart : true,
        axis      : 'y'
        },

        onThumbsShow : function(instance) {
            var $thumbs = instance.Thumbs.$list.children();
        
            $j.each( instance.group, function( index, item ) {
              if (item.contentType === 'image') {
                $thumbs.eq(index).addClass('thumb-image');
              } else if (item.contentType === 'video') {
                $thumbs.eq(index).addClass('thumb-video');
              }
            });
        } 

    })

}


//// Utility functions ////

// DOM Ready
var DOMReady = function (callback) {
    if (
        document.readyState === "interactive" ||
        document.readyState === "complete"
    ) {
        callback();
    } else if (document.addEventListener) {
        document.addEventListener("DOMContentLoaded", callback());
    } else if (document.attachEvent) {
        document.attachEvent("onreadystatechange", function () {
            if (document.readyState != "loading") {
                callback();
            }
        });
    }
};


//// Let's go! ////
DOMReady(function () {

    // siteSearch();
    headerHideShow();
    navDesktop();
    navMobile();
    smoothScroll();
    gsapAnimateScroll();
    footerMenuAccordion();
    // followCursor();
    featureTabs();
    productCircle();
    stagTextReveal();
    lottieTrigger();
    headerParallax();
    stickyElements();
    // animatedStat();
    parallaxFeatures();
    heroSlider();
    heroVideo();    
    flxScrollingText();
    flxSlideshow();
    flxAccordion();
    flxInsSlider();
    flxCsSlider();
    flxLogoSlider();
    flxImgBannerParallax();
    vanillaModal();
    socnetAnim();
    fancybox();
    // masonry();

    $j(document).on("sf:ajaxfinish", ".searchandfilter", function () {
        gsapAnimateScroll();
    });

});


//// Preloader ///
const preloader = document.querySelector("#page-preloader");

function handlePreloader() {
    if (preloader.classList.contains("loaded")) {
        preloader.classList.remove("loaded");
    }
    setTimeout(function () {
        preloader.classList.add("loaded");
    }, 600);
}
window.addEventListener("load", handlePreloader);